import ResetRulesCell from './ResetRulesCell'
import SickDaysRulesMixin from './SickDaysRulesMixin'

class SickDaysResetRulesCell extends ResetRulesCell {
    constructor() {
        super()
        this.mixin = new SickDaysRulesMixin();
    }
}

export default SickDaysResetRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysResetRulesCell.js